module.exports = __webpack_public_path__ + "img/paynow.7cc60da9.png";